<template>
  <div class="home">
    <Banner></Banner>
    <ProductService></ProductService>
    <Company></Company>
    <Journal></Journal>
    <NewsCon></NewsCon>
    <Contactus></Contactus>
  </div>
</template>
<script>
import Banner from "@/components/index/Banner.vue";
import ProductService from "@/components/index/ProductService.vue";
import Company from "@/components/index/Company.vue";
import NewsCon from "@/components/index/NewsCon.vue";
import Contactus from "@/components/index/Contactus.vue";
import Journal from "@/components/index/Journal.vue";

export default {
  name: "index",
  metaInfo() {
    return {
      title: "广州统计师事务所",
      meta: [
        { name: "keywords", content: "广州统计师事务所" },
        { name: "description", content: "广州统计师事务所" },
        { name: "viewport", content: "width=device-width, initial-scale=0.1" },
      ],
    };
  },
  data() {
    return {};
  },
  components: {
    Banner,
    ProductService,
    Company,
    NewsCon,
    Contactus,
    Journal,
  },
};
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  min-width: 1180px;
  box-sizing: border-box;
  position: relative;
  padding: 0 0 60px 0;
  // overflow-x: hidden;
  // overflow-y: auto;
}
</style>
